import { render } from "./PublicLayout.vue?vue&type=template&id=731f4bcd&scoped=true"
const script = {}

import "./PublicLayout.vue?vue&type=style&index=0&id=731f4bcd&scoped=true&lang=css"

import exportComponent from "/var/www/html/tds/tds-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731f4bcd"]])

export default __exports__